import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DEMO_MODE_BANNER_ASYNC = createAsyncTypes(
  'FETCH_DEMO_MODE_BANNER_ASYNC',
  'GlobalBanner'
)

export const FETCH_DISCOVERY_BANNER_ASYNC = createAsyncTypes(
  'FETCH_DISCOVERY_BANNER_ASYNC',
  'GlobalBanner'
)

export const DISMISS_DISCOVERY_BANNER = 'GlobalBanner/DISMISS_DISCOVERY_BANNER'

// Live permanent hide (PLG Experience §1.1) — credits exhausted or first
// investigation completed must hide the banner without a page refresh.
export const HIDE_DISCOVERY_BANNER = 'GlobalBanner/HIDE_DISCOVERY_BANNER'
